import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69a46fbf4fab3d0014a4007b/myndlayer/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a46fbf4fab3d0014a4007b/myndlayer/src/app/contact/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a46fbf4fab3d0014a4007b/myndlayer/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a46fbf4fab3d0014a4007b/myndlayer/src/components/ui/AppLogo.tsx");
